import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import sr from './locales/sr.json'

export type AppLocale = 'en' | 'sr'

export const SUPPORTED_LOCALES: { value: AppLocale; label: string }[] = [
  { value: 'sr', label: 'Srpski' },
  { value: 'en', label: 'English' },
]

const STORAGE_KEY = 'ph.locale'
// English, not the browser language: a member who has never picked a language
// gets English everywhere until they choose otherwise.
const DEFAULT_LOCALE: AppLocale = 'en'

export function loadLocale(): AppLocale {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === 'en' || saved === 'sr') return saved
  return DEFAULT_LOCALE
}

export function persistLocale(locale: AppLocale) {
  localStorage.setItem(STORAGE_KEY, locale)
}

const i18n = createI18n({
  legacy: false,
  locale: loadLocale(),
  fallbackLocale: 'en',
  messages: { en, sr },
})

// applyLocale switches the panel's language without needing a setup context, which
// is why it takes the i18n instance directly rather than useI18n(): the router
// guard adopts a member's stored language and does not run inside a component.
// Anything that is not a language we ship is ignored rather than rendering a blank
// UI on an unknown tag.
export function applyLocale(value: unknown) {
  if (value !== 'en' && value !== 'sr') return
  i18n.global.locale.value = value
  persistLocale(value)
  document.documentElement.setAttribute('lang', value)
}

export default i18n
